import { Link } from "gatsby";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import Img from "src/components/General/Image";
import React from "react";

export interface ScrollCardProps {
  link: string;
  imageUrl: string;
  cardMW: number;
  cardMH: number;
  title: string;
  subtitle?: string;
}

export const ScrollCard: React.FunctionComponent<ScrollCardProps> = (props: ScrollCardProps) => {
  return (
    <Card className="card scrollcard card-block h-100" style={{ minWidth: `${props.cardMW}px` }}>
      <Link to={props.link}>
        <Img
          src={props.imageUrl}
          style={{ minWidth: `${props.cardMW}px`, minHeight: `${props.cardMH}px` }}
          alt={`${props.title}${props.subtitle ? ` - ${  props.subtitle}` : ""}`}
        />
      </Link>
      <CardBody>
        <Link to={props.link}>
          <CardTitle>{props.title}</CardTitle>
        </Link>
        {props.subtitle && <CardSubtitle>{props.subtitle}</CardSubtitle>}
      </CardBody>
    </Card>
  );
};
